import { Grid, Stack } from "@mui/material";

import { ReactComponent as ComingSoonText } from "../../../Assets/Images/ComingSoonText.svg";
import { ReactComponent as ManageAndTrackText } from "../../../Assets/Images/ManageAndTrackIcon.svg";
import { Theme } from "../../../Style/Theme";

const ComingSoonPageLayout = ({ icon }) => {
  return (
    <>
      <Grid container direction={"row"}>
        <Grid
          item
          style={{
            maxWidth: "450px",
            height: "633px",
            flexShrink: 0,
            borderRadius: "10px",
            backgroundColor: Theme.palette.background.lightGray,
          }}
        >
          <Grid style={{ marginLeft: "70px", marginTop: "63px" }}>{icon}</Grid>
        </Grid>
        <Grid
          item
          style={{
            marginLeft: "173px",
            marginRight: "94px",
            marginTop: "279px",
            marginBottom: "303px",
          }}
        >
          <Stack direction={"column"} gap={"8px"}>
            <ComingSoonText />
            <ManageAndTrackText />
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default ComingSoonPageLayout;
